module.exports = __webpack_public_path__ + "static/media/COMPARATIVA_PLANES.45f0ab87.pdf";